import { render } from "./InvoiceDetailTabShipping.vue?vue&type=template&id=4f427aa2"
import script from "./InvoiceDetailTabShipping.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailTabShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__